// extracted by mini-css-extract-plugin
export default {"spacing":"u90z7z"};